import { useEffect, useState } from "react";

/**
 * Object URL for in-memory bytes, revoked automatically when the bytes
 * change or the consumer unmounts. Lets URL-based viewers (img src,
 * SpreadsheetView) render from a byte cache without re-downloading — an
 * object URL resolves from memory, never the network.
 */
export function useObjectUrl(
  bytes: ArrayBuffer | undefined,
  mimeType: string | undefined,
): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (bytes == null) {
      setUrl(undefined);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(
      new Blob([bytes], mimeType ? { type: mimeType } : undefined),
    );
    setUrl(objectUrl);
    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [bytes, mimeType]);

  return url;
}
